import React, { isValidElement } from 'react';
import EmptyState from '@atlaskit/empty-state';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import type { NoIssuesProps } from '@atlassian/jira-native-issue-table';
import messages from './messages';

export const NoIssues = ({ defaultNoIssuesGlyph }: NoIssuesProps) => {
	const { formatMessage } = useIntl();
	return (
		<EmptyState
			header={formatMessage(messages.noIssues)}
			imageUrl={
				!ff('em-enghealth-consolidate-jfe-assets') && typeof defaultNoIssuesGlyph === 'string'
					? defaultNoIssuesGlyph
					: undefined
			}
			renderImage={() =>
				ff('em-enghealth-consolidate-jfe-assets') && isValidElement(defaultNoIssuesGlyph)
					? defaultNoIssuesGlyph
					: undefined
			}
			testId="issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
		/>
	);
};
